<div class="ui-center-panel desktop-reauth" [ngClass]="{'desktop-reauth-change-password' : (contentData.name === 'WindowsPasswordExpired')}">
   <login-content [contentData]='contentData'>
   </login-content>
</div>